import type { HostedAgentSummary } from "@/api/client/hosted-agents"

export function agentInitials(agent: HostedAgentSummary): string {
  const configured = agent.profile.avatar.initials.trim()
  if (configured) return configured.slice(0, 3).toUpperCase()
  return agent.profile.name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase()
}

/** Existing admin-controlled identity colors are kept on the initials badge.
 * Choose the higher-contrast foreground using WCAG relative luminance. */
export function avatarForegroundColor(hexColor: string): string {
  const match = /^#([0-9a-fA-F]{6})$/.exec(hexColor.trim())
  if (!match) return "hsl(var(--foreground))"
  const rgb = parseInt(match[1], 16)
  const linear = [rgb >> 16, (rgb >> 8) & 255, rgb & 255].map((channel) => {
    const value = channel / 255
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
  })
  const luminance = linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722
  return luminance > 0.179 ? "hsl(0 0% 0%)" : "hsl(0 0% 100%)"
}
